"use client"

import z from "zod";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "../ui/dialog";
import { RequisitionsSchema } from "@/schemas/requisitions.schema";
import { useState } from "react";
import { CreateStatus } from "@/constants/status";
import { Button } from "../ui/button";
import { deleteRequisitionEntry } from "@/services/requisition.service";
import { Trash2 } from "lucide-react";

interface Props {
    entry: z.infer<typeof RequisitionsSchema>,
    updateData: () => void,
}

export default function RequisitionDeleteModal(props: Props) {
    const [open, setOpen] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState(CreateStatus.standBy);
    const [failedMessage, setFailedMessage] = useState("");

    async function deleteEntry(entryData: z.infer<typeof RequisitionsSchema>){
        setDeleteStatus(CreateStatus.onGoing)
        const formData = new FormData();
        formData.append("entryID", entryData.ID.toString());
        formData.append("domainID", entryData.DomainID.toString());
        var result = await deleteRequisitionEntry(formData);
        if(result){
            setDeleteStatus(CreateStatus.completed);
            props.updateData();
            setOpen(false);
            setDeleteStatus(CreateStatus.standBy);
        } else {
            setDeleteStatus(CreateStatus.failed);
            errorHandler(result);
        }
    }

    function errorHandler(data: any){
        console.log("Erorr occoured");
        console.log(data);
        setFailedMessage("An error occurred while creating the setting. Check console.log for more information");
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Trash2 color="#ff0000" cursor="pointer" strokeWidth={1.5} />
            </DialogTrigger>
            <DialogContent className="max-w-sm">
                <DialogTitle>Delete Requisition Entry</DialogTitle>
                <DialogDescription> 
                </DialogDescription>
                <div>
                    <p>Are you sure you want to delete: {props.entry.MainFolder}/{props.entry.SubFolder}?</p>
                    <p>This will delete the folder on the FTP server and ALL files within the folders</p>
                </div>
                <div>
                    <Button onClick={() => deleteEntry(props.entry)}>Delete</Button>
                </div>
                <DialogFooter>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-start-1 col-end-7 rounded-md border-black">
                            {deleteStatus == CreateStatus.onGoing && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Deleting Entry...</p>
                                </div>
                            )}
                            {deleteStatus == CreateStatus.completed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Deleted Entry! The modal will close momentarily</p>
                                </div>
                            )}
                            {deleteStatus == CreateStatus.failed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>{failedMessage}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}